export default {
    'pages': require('./collection.pages').default,

    'users': require('./collection.users').default,

    'roles': require('./collection.roles').default,

    'settings': require('./collection.settings').default,

    'page.page_images': require('./collection.page-page_images').default,

    'page.page_files': require('./collection.page-page_files').default,

    'page.panels': require('./collection.page-panels').default,

    'page.page_tabs': require('./collection.page-page_tabs').default,

    'services': require('./collection.services').default,

   // 'videos': require('./collection.videos').default,

    'panels': require('./collection.panels').default,

    'news_posts': require('./collection.news_posts').default,

    'staff_members': require('./collection.staff_members').default,

    'news_posts': require('./collection.news_posts').default,

    'panel.banner.panel_items': require('./collection.panel-panel_items').default,
    'panel.project-list.panel_items': require('./collection.project-list-panel_items').default,

    'panel.project-list.panel_items': require('./collection.panel-panel_items').default,
    'panel.values.panel_items': require('./collection.panel-panel_items').default,

    //'panel.carousel.panel_items': require('./collection.panel-panel_items').default,

    // 'panel.file-download.panel_items': require('./collection.panel-file-download-panel_items').default,

    'panel.form.panel_form_fields': require('./collection.panel-form-panel_form_fields.js').default,

    // 'products': require('./collection.products').default,

    // 'categories': require('./collection.categories').default,

    // 'orders': require('./collection.orders').default,

    // 'order.order_statuses': require('./collection.order-order_statuses').default,

    // 'product_attributes': require('./collection.product_attributes').default,

    // 'product_illustrations': require('./collection.product_illustrations').default,

    // 'product.prices': require('./collection.product-prices').default,

    // 'product.product_images': require('./collection.product-product_images').default,

    // 'product.product_tabs': require('./collection.product-product_tabs').default,

    // 'customers': require('./collection.customers').default,

    'campaigns': require('./collection.campaigns').default,

    'campaign.messages': require('./collection.messages').default,

    'contacts': require('./collection.contacts').default,

    'contact.messages': require('./collection.messages').default,

    'messages': require('./collection.messages').default,

    'message.message_statuses': require('./collection.message-message_statuses').default,

    // 'resources': require('./collection.resources').default,

    'customer.orders': require('./collection.customer-orders').default,

    'subscribers': require('./collection.subscribers').default,

    'news_categories': require('./collection.news_categories.js').default,

    // 'page.page_videos': require('./collection.page-page_videos.js').default,

    // 'stockists': require('./collection.stockists.js').default,

    // 'quick_links': require('./collection.quick_links.js').default,

    'redirect_urls': require('./collection.redirect_urls.js').default,

    'layouts': require('./collection.layouts.js').default,
}


// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.js